import { createAction, props } from '@ngrx/store';

import { AuthCodeData } from 'src/app/model/api/auth-code-data';
import { InvitationData } from 'src/app/model/api/invitation-data';
import { TokenData } from 'src/app/model/api/token-data';
import { Lang } from 'src/app/model/lang';
import { User } from 'src/app/model/user';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const authCode = createAction('AUTH_CODE', props<{ username: string; password: string }>());
export const authCodeSuccess = createAction('AUTH_CODE_SUCCESS', props<{ authCodeData: AuthCodeData }>());
export const authCodeFailed = createAction('AUTH_CODE_FAILED', props<{ errorMessage: string }>());
export const getTokenSuccess = createAction('GET_TOKEN_SUCCESS', props<{ tokenData: TokenData; userId: number; redirect: boolean }>());
export const getTokenFailed = createAction('GET_TOKEN_FAILED', props<{ errorMessage: string; dest?: string }>());

//----------------- NEW 2FA Auth
export const authMfaCodeReset = createAction('AUTH_MFA_CODE_RESET');
export const authMfaCode = createAction('AUTH_MFA_CODE', props<{ username: string; password: string, mfaCode?: string; }>());
export const authMfaCodeSuccess = createAction('AUTH_MFA_CODE_SUCCESS', props<{ authCodeData: AuthCodeData }>());
export const authMfaCodeInvalidMfaCode = createAction('AUTH_MFA_CODE_INVALID_MFA_CODE');
export const authMfaCodeFailed = createAction('AUTH_MFA_CODE_FAILED', props<{ errorMessage: string }>());
export const getMfaTokenSuccess = createAction('GET_MFA_TOKEN_SUCCESS', props<{ tokenData: TokenData; userId: number; redirect: boolean }>());
export const getMfaTokenFailed = createAction('GET_MFA_TOKEN_FAILED', props<{ errorMessage: string; dest?: string }>());
//----------------- NEW 2FA Auth


export const authLogout = createAction(AUTH_LOGOUT);
export const signupInit = createAction('SIGNUP_INIT');
export const signupReset = createAction('SIGNUP_RESET');
export const signup = createAction('SIGNUP', props<{
    user: User; isTechnician: boolean; fromInvitation: boolean; invitationData?: InvitationData; lang?: Lang
}>());
export const userSignupSuccess = createAction('USER_SIGNUP_SUCCESS', props<{
    message: string; userId: number; fromInvitation: boolean; invitationData?: InvitationData;
}>());
export const technicianSignupSuccess = createAction('TECHNICIAN_SIGNUP_SUCCESS', props<{
    message: string; userId: number; fromInvitation: boolean; invitationData?: InvitationData;
}>());
export const signupFailed = createAction('SIGNUP_FAILED', props<{ errorMessage: string }>());
export const autoLogin = createAction('AUTO_LOGIN', props<{ dest: string }>());
export const unauthRoute = createAction('UNAUTH_ROUTE', props<{ dest: string }>());
export const resetPassword = createAction('RESET_PASSWORD', props<{ email: string }>());
export const resetPasswordSuccess = createAction('RESET_PASSWORD_SUCCESS', props<{ message: string }>());
export const resetPasswordFailed = createAction('RESET_PASSWORD_FAILED', props<{ errorMessage: string }>());
export const updatePassword = createAction('UPDATE_PASSWORD', props<{
    email: string; countryName: string; pwd: string; verification: string; time: number; lang: Lang;
}>());
export const updatePasswordSuccess = createAction('UPDATE_PASSWORD_SUCCESS', props<{ message: string }>());
export const updatePasswordFailed = createAction('UPDATE_PASSWORD_FAILED', props<{ errorMessage: string }>());
export const confirmEmailReset = createAction('CONFIRM_EMAIL_RESET');
export const confirmEmail = createAction('CONFIRM_EMAIL', props<{ id: number; data: string }>());
export const confirmEmailSuccess = createAction('CONFIRM_EMAIL_SUCCESS', props<{ message: string }>());
export const confirmEmailFailed = createAction('CONFIRM_EMAIL_FAILED', props<{ errorMessage: string }>());

export const getHelpToken = createAction('INSERT_HELP_TOKEN', props<{
    tokenData: TokenData;
}>());
export const setUserToken = createAction('SET_USER_TOKEN', props<{
    tokenData: TokenData;
}>());

export const ACTION_LOGOUT_NAME = '[Auth] Logout';
